import AppHeader from '../../modules/core/components/AppHeader';
import {toggleOpenMainSideBar} from '../../modules/core/functions' 
import MainSideBarMenu from '../../modules/core/components/menu/MainSideBarMenu';

const AuthLayout =({children}) =>{
    
    return(
        <>
            <div className="sidebar">
                <div className="sidebar-inner">
                    <div className="sidebar-logo">
                        <div className="peers ai-c fxw-nw">
                        <div className="peer peer-greed">
                            <a className="sidebar-link td-n" href="#/dashboard">
                            <div className="peers ai-c fxw-nw">
                                <div className="peer">
                                <div className="logo">
                                    <img src="assets/static/images/logo.png" alt=""/>
                                </div>
                                </div>
                                <div className="peer peer-greed">
                                    <h5 className="lh-1 mB-0 logo-text">Menote</h5>
                                </div>
                            </div>
                            </a>
                        </div>
                        <div className="peer">
                            <div className="mobile-toggle">
                                <a href="#/" className="sidebar-toggle td-n" onClick={toggleOpenMainSideBar}>
                                    <i className="ti-arrow-circle-left"></i>
                                </a>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="sidebar-content">
                        <MainSideBarMenu/>
                    </div>
                </div>
            </div>
            <div className="page-container">
                <div className="header navbar">
                    <AppHeader/>
                </div>
                <div className="main-content bgc-grey-100">
                    <div id="mainContent">
                        <div className="container">
                            {children}
                        </div>                        
                    </div>
                </div>
            </div>
        </>
    )
}

export default AuthLayout;


